import { del, get, post, put } from './request'

interface Recreation {
    supplier: string;
    propertyId: string;
    property: {
        recreations: Array<object>
    };
}

export const getRecreations = (supplier: string, propertyid: string) => get(`/property/recreations?supplier=${supplier}&propertyid=${propertyid}`)
export const addRecreation = (recreation: Recreation) => post('/property/recreations', recreation)
export const updateRecreation = (recreation: Recreation) => put('/property/recreations', recreation)
export const deleteRecreation = (recreation: Recreation) => del('/property/recreations', recreation)

export const addRecreationDetails = (recreation: Recreation) => post('/property/recreations/details', recreation)
export const updateRecreationDetails = (recreation: Recreation) => put('/property/recreations/details', recreation)
export const deleteRecreationDetails = (recreation: Recreation) => del('/property/recreations/details', recreation)

export const addRecreationSchedule = (recreation: Recreation) => post('/property/recreations/schedule', recreation)
export const updateRecreationSchedule = (recreation: Recreation) => put('/property/recreations/schedule', recreation)
export const deleteRecreationSchedule = (recreation: Recreation) => del('/property/recreations/schedule', recreation)